import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectCentralizedDispatchStore = (state) => state.centralizedDispatch;

export const makeSelectFilterSettings = () => createSelector(
  selectCentralizedDispatchStore,
  ({ filterSettings }) => filterSettings,
);

export const makeSelectTripsSearchCriteria = () => createSelector(
  selectCentralizedDispatchStore,
  ({ tripsSearchCriteria }) => tripsSearchCriteria,
);

export const makeSelectTripsOrderFields = () => createSelector(
  selectCentralizedDispatchStore,
  ({ tripsOrderFields }) => tripsOrderFields,
);

export const makeSelectDriversSearchCriteria = () => createSelector(
  selectCentralizedDispatchStore,
  ({ driversSearchCriteria }) => driversSearchCriteria,
);

export const makeSelectDriversRadiusRequestParams = () => createSelector(
  selectCentralizedDispatchStore,
  ({ driversRadiusRequestParams }) => driversRadiusRequestParams,
);
